import type { ComponentProps } from 'react';

import type { FieldLayoutOptions } from './useFieldLayout';
import { FormPasswordInput } from './FormField';
import { useFieldLayout } from './useFieldLayout';

export type PasswordFieldProps = Omit<
  ComponentProps<typeof FormPasswordInput>,
  'label' | 'inputHeight' | 'inputBackground'
> &
  FieldLayoutOptions;

export const PasswordField = ({ label, hideLabel, ...fieldProps }: PasswordFieldProps) => {
  const field = useFieldLayout({ label, hideLabel });

  return (
    <FormPasswordInput
      label={field.label}
      aria-label={field.ariaLabel}
      inputHeight={field.inputHeight}
      inputBackground={field.inputBackground}
      {...fieldProps}
    />
  );
};
